import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`When you make significant changes to a published package, we recommend updating the version number to communicate the extent of the changes to others who rely on your code.`}</p>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` If you have linked a git repository to a package, updating the package version number will also add a tag with the updated release number to the linked git repository.`}</p>
    </Note>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`To change the version number in `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`, on the command line, in the package root directory, run the following command, replacing `}<inlineCode parentName="p">{`<update_type>`}</inlineCode>{` with one of the `}<a parentName="p" {...{
            "href": "about-semantic-versioning"
          }}>{`semantic versioning`}</a>{` release types (patch, major, or minor):`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm version <update_type>
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Run `}<inlineCode parentName="p">{`npm publish`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Go to your package page (`}<inlineCode parentName="p">{`https://npmjs.com/package/<package>`}</inlineCode>{`) to check that the package version has been updated.`}</p>
      </li>
    </ol>
    <p>{`For more information on `}<inlineCode parentName="p">{`npm version`}</inlineCode>{`, see the `}<a parentName="p" {...{
        "href": "/cli/version"
      }}>{`CLI documentation`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      